import React, { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, Skeleton } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import RoundButton from "../shared/components/round-btn";
import { AddCircle } from "iconsax-react";
import styles from './cards.module.scss';
import Card from "./card";
import CardsUiStore from "./cards-ui-store";
import AddCardModal from "./add-card-modal";

const uiStore = new CardsUiStore();


const Cards = observer(({ history, context }) => {
    const { cards } = uiStore;
    const [loading, setLoading] = useState(false);
    const [showAddCardModal, setShowAddCardModal] = useState(false);

    useEffect(() => {

        async function fetchData() {
            uiStore.initliazeContext(context);
            setLoading(true);
            await uiStore.fetchCards();
            setLoading(false);
        }

        fetchData()
    }, [context]);

    return (
        <>
            <Header page="cards"></Header>

            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box>
                        <Grid container>
                            <Grid item xl={10} lg={10} md={9} sm={9} xs={5} sx={{ mt: 2 }}>
                                <Typography variant="h5" color='#242333'><b>My Cards</b></Typography>
                            </Grid>
                            <Grid item xl={2} lg={2} md={3} sm={3} xs={7} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <RoundButton
                                    startIcon={
                                        <AddCircle
                                            size="24"
                                            variant="Bulk"
                                        />
                                    }
                                    variant="contained"
                                    sx={{ mr: 1, mt: 2 }}
                                    onClick={() => setShowAddCardModal(true)}
                                >

                                    New Card
                                </RoundButton>
                            </Grid>
                        </Grid>
                    </Box>



                    <Box sx={{ display: "flex", justifyContent: 'center' }}>
                        <Box sx={{ display: "flex", flexWrap: 'wrap', mt: 4, width: '100%', justifyContent: 'center' }}>
                            {loading ?
                                <>
                                    <Skeleton variant="rounded" className={styles.cardPlaceHolder} height={230} sx={{ ml: 2, mb: 2 }} />
                                    <Skeleton variant="rounded" className={styles.cardPlaceHolder} height={230} sx={{ ml: 2, mb: 2 }} />
                                    <Skeleton variant="rounded" className={styles.cardPlaceHolder} height={230} sx={{ ml: 2, mb: 2 }} />
                                </>
                                :
                                cards.map(
                                    item => (
                                        <Card key={item._id} card={item} uiStore={uiStore} />
                                    )
                                )
                            }
                        </Box>
                    </Box>
                </Box>
                <AddCardModal uiStore={uiStore} show={showAddCardModal} setShow={setShowAddCardModal} history={history} />
            </Grid>
            <Footer></Footer>
        </>
    );
});

export default Cards;